import React from 'react';
import { FaGraduationCap, FaUniversity } from "react-icons/fa";
import { BiMap } from "react-icons/bi";

const Education = () => {
    return (
        <>
            <div className='flex items-center text-xl font-bold'>
                <FaGraduationCap className='w-6 h-6 mr-2 mb-2'/> Education
            </div>
            <div className='ml-8'>
                <div className="flex items-center mb-2">
                    <FaUniversity className='w-4 h-4 mr-2'/> Institute of Science, Trade & Technology (ISTT)
                </div>
                <div className="flex items-center mb-2">
                    <FaGraduationCap className='w-4 h-4 mr-2'/> Bachelor of Science in Computer Science and Engineering
                </div>
                <div className="flex items-center mb-2">
                    <BiMap className='w-4 h-4 mr-2'/> Dhaka, Bangladesh
                </div>
                <div className="flex items-center mb-2">
                    <FaGraduationCap className='w-4 h-4 mr-2'/> Graduated: 2017 - 2022
                </div>
            </div>
        </>
    );
};

export default Education;
